import React from 'react';
import PropTypes from 'prop-types';
import { DropdownRoot, DropdownTrigger, DropdownPortal } from '@lsq/nextgen/v2/dropdown';
import Content, { MODE } from './Content';

/**
 * Stateless single-select. Composes the dropdown primitives and passes the
 * Trigger (as children) to DropdownTrigger with asChild. The consumer owns
 * `open`/`onOpenChange`/search state — see SearchableSingleSelect for a
 * batteries-included wrapper.
 */
const SingleSelect = ({
  open,
  onOpenChange,
  options,
  selectedOption,
  onSelection,
  searchValue,
  onSearchChange,
  children,
  contentClassName = ''
}) => {
  const selectedOptions = selectedOption ? [selectedOption] : [];

  const handleChange = (next) => {
    onSelection?.(next[0] ?? null);
  };

  return (
    <DropdownRoot open={open} onOpenChange={onOpenChange}>
      <DropdownTrigger asChild>{children}</DropdownTrigger>
      <DropdownPortal>
        <Content
          mode={MODE.SINGLE}
          options={options}
          selectedOptions={selectedOptions}
          onChange={handleChange}
          searchValue={searchValue}
          onSearchChange={onSearchChange}
          className={contentClassName}
        />
      </DropdownPortal>
    </DropdownRoot>
  );
};

SingleSelect.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }))
    .isRequired,
  selectedOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  onSelection: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  contentClassName: PropTypes.string
};

export default SingleSelect;
